import { render, staticRenderFns } from "./NewExistingTabs.vue?vue&type=template&id=5aef2050"
import script from "./NewExistingTabs.vue?vue&type=script&lang=js"
export * from "./NewExistingTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports